const defaultState = {
	useYnOptions: [],
	searchParams: { title: '', content: '', useYn: 'Y' },
	notifications: {
		currentPage: 1,
		pageUnit: null,
		totalSize: 0,
		data: []
	},
	notificationsModal: { opened: false },

	schema: null
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
